export const paginator:any = {
    paginatorTemplate:'CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown',
    rowsPerPageOptions:[10, 20, 50, 100, 150, 200]
}
